import axios from 'axios';

const instance = axios.create({ baseURL: 'https://latino-match-870f58790994.herokuapp.com/' })


export default instance;


